
<div class="parent fx-row">
  <div class="left">
    <about-company></about-company>
  </div>
  <div class="right">
    <div class="my-3 d-flex justify-content-end">
      <button mat-button color="primary" class="__home" (click)="openTracking()">
        <mat-icon class="tracking-icon">location_on</mat-icon>
        <span>Tracking</span>
      </button>
    </div>
    <section>
      <form [formGroup]="login" (ngSubmit)="onSubmit()">
        <mat-card>
          <h2>
            Login
          </h2>
          <h5 class="mat-h5-paragraph">Enter your login details below</h5>
          <mat-card-content>
            <mat-form-field appearance="outline" subscriptSizing="dynamic" hideRequiredMarker class="email-field">
              <mat-label>Enter Email Id</mat-label>
              <input class="_login_email_field" matInput placeholder="Enter Email Id" formControlName="email" autocomplete="off">
              <mat-icon matSuffix class="email-icon">mail_outline</mat-icon>
              @if (email.hasError('required') && email.touched && email.invalid) {
                <mat-error>Email is required</mat-error>
              }
              @if (email.hasError('email') && email.touched && email.invalid) {
                <mat-error>Enter a valid Email</mat-error>
              }
            </mat-form-field>
            <div class="field-spacer"></div>
            <mat-form-field appearance="outline" subscriptSizing="dynamic" hideRequiredMarker class="password-field">
              <mat-label>Password</mat-label>
              <input class="_login_password_field" [type]="hide ? 'password' : 'text'" matInput placeholder="Password" formControlName="password"
                autocomplete="off"/>
                <mat-icon class="__show_psw" matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                @if (password.hasError('required') && password.touched && password.invalid) {
                  <mat-error>Password is required</mat-error>
                }
              </mat-form-field>
            </mat-card-content>
            <div class="d-flex align-items-center justify-content-between mt-3 actions-row">
              <mat-checkbox formControlName="rememberMe" class="remember-me-check" tabindex="-1">Remember Me</mat-checkbox>
              <a class="forgot-link" [routerLink]="['/forgetPassword']" tabindex="-1">Forgot Password?</a>
            </div>
            <mat-card-actions>
              <div class="button-flex-container">
                <button type="submit" class="material-cust-large-button" color="primary">Login</button>
              </div>
            </mat-card-actions>
          </mat-card>
        </form>
      </section>
    </div>
  </div>